// src/pages/Quiz.js
// The scent quiz on its own page, linked from the nav and the home page.

import React from 'react';
import ScentQuiz from '../components/ScentQuiz';
import usePageTitle from '../hooks/usePageTitle';

const Quiz = () => {
    usePageTitle('Find Your Scent', 'Not sure which perfume oil is for you? Take the MAISON D\'OUD scent quiz: six quick questions to find your perfect match.');

    return (
        <div className="bg-background min-h-screen pt-8 transition-colors duration-300">
            <ScentQuiz />
        </div>
    );
};

export default Quiz;
